import { render, staticRenderFns } from "./ChoiceCard.vue?vue&type=template&id=1581b4da&scoped=true&"
import script from "./ChoiceCard.vue?vue&type=script&lang=ts&"
export * from "./ChoiceCard.vue?vue&type=script&lang=ts&"
import style0 from "./ChoiceCard.vue?vue&type=style&index=0&id=1581b4da&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1581b4da",
  null
  
)

export default component.exports